import { render, staticRenderFns } from "./CustomerRelation.vue?vue&type=template&id=25801caa&scoped=true&"
import script from "./CustomerRelation.vue?vue&type=script&lang=js&"
export * from "./CustomerRelation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRelation.vue?vue&type=style&index=0&id=25801caa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25801caa",
  null
  
)

export default component.exports